module.exports = __webpack_public_path__ + "static/rikunavi-logo-6723ba7f28c3657be270a7c1261b7896.png";